/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Resume_TitleInputs */



/**
* | output |
* | --- |
* | "Resume the recording?" |
*
* @param {Meeting_Offline_Resume_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_resume_title = /** @type {((inputs?: Meeting_Offline_Resume_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Resume_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opname hervatten?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reprendre l'enregistrement ?")
	return /** @type {LocalizedString} */ ("Resume the recording?")
});